import React, { useState } from 'react'
import './FeatureTabs.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { faLocationArrow } from '@fortawesome/free-solid-svg-icons'
import { faAlignCenter } from '@fortawesome/free-solid-svg-icons'
import { faSearchPlus } from '@fortawesome/free-solid-svg-icons'
import { faAddressCard } from '@fortawesome/free-solid-svg-icons'
import { faShieldAlt } from '@fortawesome/free-solid-svg-icons'

const FeatureTabs = () => {
    const [tabIndex, setTabIndex] = useState(0);
    function toggleTabs(i){
        setTabIndex(i)
    }
    // === Tabs Data ===
    const tabsData = [
        {
            btnName: 'Find Businesses',
            btnIcon: faLocationArrow,
            contentTitle: 'Find Businesses Near You',
            contentDescriptions: ['Elite Partyz app allows you to create an event no matter your location. Find suppliers for your party / event near you or even in another city.'],
            featureList: ['Plan an event / party locally or in another city', 'View suppliers relevant to your event location', 'View suppliers relevant to your event, search categories and keywords'],
            phoneIMGPath: '/img/f-1.webp',
            btnURL: '#register'
        },
        {
            btnName: 'Invites & RSVP',
            btnIcon: faAlignCenter,
            contentTitle: "Send Invitations & Receive RSVP's",
            contentDescriptions: ['Elite Partyz simplifies invitations, import contacts from your phone or manually add guests by entering their details.', 'When you are ready, you simply press Invite All, an sms is sent to all of your guest with a link in which opens up your invitation, informing your guests what event it is, where it is located, what it is for, location, date and time.', 'Your guests can simply accept the invitation or select if they cannot make it to the event, providing the simplest and most convenient way to track who is coming to your event and who isn’t.'],
            featureList: ["Invite guests from your phones contacts.", "Manually enter in guests if they are not already in our phones contacts Automatically the app informs you of who is attending your event and who isn't", "making RSVP so easy and knowing at all times how many people to cater for that special event."],
            phoneIMGPath: '/img/f-2.webp',
            btnURL: '#register'
        },
        {
            btnName: 'Chat',
            btnIcon: faSearchPlus,
            contentTitle: 'Chat With Suppliers & Businesses',
            contentDescriptions: ['Our internal chat system allows you to talk to businesses and suppliers about their products and services, making contact and communication so simple and organised all within the app.'],
            featureList: ['Communicate directly via the internal messaging system with suppliers', 'Members and Businesses can send images to one another, for example if you want a particular cake made, you can share photos via message.', 'Keep track of communication between yourself and businesses on the platform, keeping everything in the one simple app.'],
            phoneIMGPath: '/img/f-3.webp',
            btnURL: '#register'
        },
        {
            btnName: 'Event Management',
            btnIcon: faAddressCard,
            contentTitle: 'Create, Add & Manage Multiple Events At Any One Time',
            contentDescriptions: ['Elite Partyz app makes creating, managing and arranging Party’s, Events, Weddings and more so simple.', 'You can have multiple events set in the app, for example you can create a Birthday party event and manage everything for that, whilst also planning a number of other events all in the one simple app.', 'Elite Partyz mobile app is designed and built for organising any type of party, event or function.'],
            featureList: ['Create and manage a single event or multiple events at anytime', 'There are no limits on how many events you create and manage', 'Create and manage events in any town, city or suburb in Australia'],
            phoneIMGPath: '/img/f-4.webp',
            btnURL: '#register'
        },
        {
            btnName: 'Secure Payments',
            btnIcon: faShieldAlt,
            contentTitle: 'Manage Budgets and Payments Easily',
            contentDescriptions: ['With any event you can set a budget, the Elite Partyz app helps you manage your budget and expenses for each event.', 'Making payments to suppliers and businesses is simple, once the business accepts your purchase, hire or rental then the system automatically generates and invoice and payment request to the supplier.'],
            featureList: ['Manage budgets simply and easily within the app', 'Multiple payment options are available to pay for your transactions', 'Businesses can accept PAY ID, Electronic Transfer and Credit Cards* Depending on the business, our platform allows for all payment methods'],
            phoneIMGPath: '/img/f-5.webp',
            btnURL: '#register'
        },
    ]
    // === Featurs tabs ===
    return (
        <div className="feature-tabs">
            <div className="container">
                <div className="feauter-tabs-main-content">
                    {/* === Tabs Button Group === */}
                    <div className="tabs-btn-group">
                        {/* === Button Loop === */
                            tabsData.map((button, btnNumber) => {
                                return(
                                    <div className={ tabIndex === btnNumber ? "tabs-btn active" : "tabs-btn"} key={`BUTTON${btnNumber}`} onClick={() => toggleTabs(btnNumber)}>
                                        <span className="btn-icon"><FontAwesomeIcon icon={button.btnIcon} /></span>
                                        <span className="btn-name">{button.btnName}</span>
                                        <div className="animation"></div>
                                    </div>
                                )
                            })
                        }

                    </div>

                    {/* === Tabs content group === */}
                    <div className="tabs-content-group">
                        {/* === Tabs Content loop === */
                            tabsData.map((content, contentNumber) => {
                                return(
                                    <div className={ tabIndex === contentNumber ? "tabs-single-content active" : "tabs-single-content"} key={`CONTENT${contentNumber}`}>
                                        <div className="tabs-single-content-left">
                                            <h4 className="title">{content.contentTitle}</h4>
                                            {/* === P segment loop === */
                                                content.contentDescriptions.map((description, di) => {
                                                    return(
                                                        <p key={`DES${di}`} className="description">{description}</p>
                                                    )
                                                })
                                            }
                                            <ul className="si-feature">
                                                {/* === List Loop ===  */
                                                    content.featureList.map((feature, fi) => {
                                                        return(
                                                            <li className="si-item" key={`FL${fi}`}>
                                                                <span className="icon"><FontAwesomeIcon icon={faCheck} /></span>
                                                                <span className="text">{feature}</span>
                                                            </li>
                                                        )
                                                    })
                                                }
                                                
                                            </ul>
                                            <a href={content.btnURL} className="tabs-si-btn">Register Interest</a>
                                        </div>
                                        <div className="tabs-single-content-right">
                                            <img src={content.phoneIMGPath} alt="event" />
                                        </div>
                                    </div>
                                )
                            })
                        }
                        
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FeatureTabs
